import React from 'react'

import Text from '../../ui/Text'
import isAura from '../../lib/isAura'
import isDawn from '../../lib/isDawn'
import isHalo from '../../lib/isHalo'
import isLuna from '../../lib/isLuna'
import { MeasurementDeviceProducts } from '../enums/Products'

export const getProductName = (productId?: string | number, formatted = true): string | React.ReactElement => {
    if (!productId) return ''
    const id = Number(productId)
    if (id === MeasurementDeviceProducts.AmpGuard) return 'Charge Amps Amp Guard'
    if (id === MeasurementDeviceProducts.AmpGuard2) return 'Charge Amps Amp Guard 2'
    if (id === MeasurementDeviceProducts.Enegic) return 'Perific'
    if (isAura(id)) return formatted ? <Text code={'lblAuraControlWidget'} /> : 'Charge Amps Aura'
    if (isDawn(id)) return formatted ? <Text code="lblDawnControlOcppWidget" /> : 'Charge Amps Dawn'
    if (isHalo(id)) return formatted ? <Text code="lblHaloControlWidget" /> : 'Charge Amps Halo'
    if (isLuna(id)) return formatted ? <Text code="lblLunaControlOcppWidget" /> : 'Charge Amps Luna'
    return ''
}

export const getShortProductName = (productId: string | number) => {
    switch (productId) {
        case MeasurementDeviceProducts.AmpGuard:
            return 'AG1'
        case MeasurementDeviceProducts.AmpGuard2:
            return 'AG2'
        case MeasurementDeviceProducts.Enegic:
            return 'PRFC'
        default:
            return ''
    }
}
